import round from "../../../../utils/round";

/**
 *
 * @param {Number} overall
 * @param {Number} percents
 * @param {Boolean} enter
 * @returns
 */
const getOverallPercents = (overall, percents, enter) => {
  if (enter) {
    const fragment = (1 - overall) * percents;
    return round(overall + fragment, 10000);
  } else {
    const fragment = overall * percents;
    return round(overall - fragment, 10000);
  }
};

export default getOverallPercents;
